/**
 * Created by joerg on 19.06.17.
 */
import Utils from '../utils/Utils'
import pdfmake from 'pdfmake/build/pdfmake.min'
import './vfs_fonts'

import dwlogo from '../assets/images/logo.png';

import styles from '../App.scss';
import BaseEntriesStore from '../stores/BaseEntriesStore';
import BrespaAnalyseStore from '../stores/BrespaAnalyseStore';
import HalbfertigAnalyseStore from '../stores/HalbfertigAnalyseStore';
import OrtbetonAnalyseStore from '../stores/OrtbetonAnalyseStore';
import InputModel from "../models/InputModel";
import moment from 'moment';
import packageJson from '../../package.json';
import {runInAction} from "mobx";
//import canvg from 'canvg-browser/index'

class PdfCreator {

    datauris = {hmldu:null,johdu:null,peidu:null,prldu:null,dwdu:null,vchart:null,skizze:null}
    druckdaten = null;
    stores = {basic:BaseEntriesStore,brespa:BrespaAnalyseStore,hfstore:HalbfertigAnalyseStore,obstore:OrtbetonAnalyseStore}

    constructor(){
        this.VERSION = packageJson.version;
        Utils.getDataUri(dwlogo,(uri)=>{this.datauris.dwdu = uri});

    }
    async fetchData(){
        // this.state = "pending";
        try {
            const daten = await window.jQuery.get(`${process.env.PUBLIC_URL}/json/druckdaten.json`);
            console.log("found druckdaten:",daten)
            this.druckdaten = daten;
        }catch(e){
            console.error("error getting daten",e)
        }
    }

    createDoc(print=true){
        var self = this;
        this.datauris.skizze = BaseEntriesStore.skizzedatauri;
        pdfmake.fonts = {
            joey: {
                normal: 'FS-Joey-Regular.ttf',
                medium: 'FS-Joey-Medium.ttf',
                bold: 'FS-Joey-Bold.ttf'
            },
            roboto:{
                normal:'Roboto-Regular.ttf'
            }
        };

            //this.datauris.vchart = data;
            var docDefinition = {
                images:this.datauris,
                content: this.getPages(),
                footer: function(currentPage, pageCount) { return [
                    {columns:[{text: 'Version: '+self.VERSION + '/ Stand: '+moment().locale('de').format('L'),alignment: 'left',fontSize: 9},
                        { text:'Seite '+ currentPage.toString() + '/' + pageCount, alignment: 'right',fontSize: 9 }],margin:[80,0,80,0]}];
                },
                defaultStyle: {
                    font: 'joey',
                    fontSize: 12,
                    columnGap: 20,
                },

                styles:{
                    header: {
                        fontSize: 13,
                        bold: true,
                        //color:styles.consolis_blau,
                        alignment: 'center'
                    },
                    subheader: {
                        fontSize: 12,
                        bold: true
                    },
                    tableHeader: {
                        fontSize: 13,
                        bold: true,
                        //color:styles.consolis_dunkelgrau,
                        alignment: 'center'
                    },
                    laufCenter:{
                        alignment: 'center'
                    },
                    lauf:{
                        fontSize:10,
                        //color:styles.consolis_dunkelgrau,
                    },
                    adresse:{
                        fontSize: 9,
                    }

                }
            };
            if(print){

                var pd = pdfmake.createPdf(docDefinition);
                pd.getBuffer((buff)=>{
                    this.printWithPdfJS(buff);
                })
            }else{
                pdfmake.createPdf(docDefinition).download("Parkraum.pdf");
            }


    }
    printWithPdfJS(pdfdata){
        var viewercontent = document.getElementById('pdfview').contentWindow;
        var container = document.getElementById('pdfview').contentDocument.getElementById('viewerContainer');
        viewercontent.PDFViewerApplication.open(pdfdata).then(function(){

        });
        container.addEventListener('pagesloaded', function () {
            viewercontent.PDFViewerApplication.eventBus.dispatch('print');
        });


    }

    getPages(){
        //this.page_1();
        return this.page_0().concat(this.page_1()).concat(this.page_2()).concat(this.page_3());
    }

    markbrespa(txt){
        if(txt.indexOf("BRESPA®")>=0){
          let tarr =  txt.split("BRESPA®");
          let outarr = []
            for (let i = 0; i < tarr.length ; i++) {
                outarr.push(tarr[i]);
                if(i !== tarr.length-1){
                    outarr.push({text: 'BRESPA®', bold: true});
                }

            }
            return outarr;
        }
        return [txt];
    }

    pulldata(im,arr){
        if(im.type === "entry"){
            if(im.field === "none"){
                arr.push([Utils.stripTags(im.title), {text:im.default,bold:true,alignment:'right'}]);
            }else{
                let field = this.stores[im.store][im.field];
                arr.push([(field.title)?Utils.stripTags(field.title):im.title, {text:field.getCombinedVal(),bold:true,alignment:'right'}]);
            }
            return arr
        }else if(im.type === "entry2") {
            if(im.field === "none"){
                arr.push([Utils.stripTags(im.title), {text:im.default,bold:true,alignment:'right'},"",""]);
            }else{
                let field = this.stores[im.store][im.field];
                arr.push([(field.title)?Utils.stripTags(field.title):{text:this.markbrespa(im.title)}].concat(field.getCombinedArrayVal()));
            }
            return arr
        }else if(im.type === "h2") {
            arr.push([{text: Utils.stripTags(im.title), style: 'subheader'},"","",""]);
            return arr
        }else if(im.type === "h3") {
            arr.push([{text: Utils.stripTags(im.title), bold: true},"","",""]);
            return arr
        }else if(im.type === "h3_2") {
            arr.push([{text: Utils.stripTags(im.title), bold: true},"","",""]);
            return arr
        }else if(im.type === "h6"){
                arr.push([{text:Utils.stripTags(im.title),bold:false},  "","",""]);
                return arr
        }else if(im.type === "image"){
            arr.push([{image:im.field,width:250,margin:[50,0,0,0]},"","",""]);
            return arr
        }else if(im.type === "switch"){
            let field = this.stores[im.store][im.field];
            let val = field.value[im.subfield];
           // let arr = []
            im[val].forEach((im)=>{
                this.pulldata(im,arr)
            });
            return arr;
        }else if(im.type.indexOf("summary")>=0){
            arr.push([im]);
            return arr
        }
    }

    page_0(){
        let bstore = BaseEntriesStore;
        let brespastore = BrespaAnalyseStore;
        var tbl = {table: {
                widths: ['auto', '*'],
                body: []
            }};
        tbl = {table: {
                widths: [300, '*','auto','auto'],
                body: []
            }};
        tbl.table.body.push([{text: bstore.projektname.value},
            "","",""]);
        tbl.table.body.push([{text:"Bauort: "+ bstore.plz.value},
            "","",""]);
        this.druckdaten.seite1.forEach((im)=>{
            //var titl = Utils.stripTags(im.title);
            console.log(im.field);
            let arr = []
            let d = this.pulldata(im,arr);
            arr.forEach((v)=>{
                tbl.table.body.push(v)
            });

        });
        let base =  [

            {
                stack:[{image:'dwdu',width:150},
                    {stack:[
                            {text:'DW SYSTEMBAU GMBH'},
                            {text:'Stockholmer Straße 1'},
                            {text:'29640 Schneverdingen\n\n'},
                            {text:'Fon +49(0) 5193 85 0\n\n'},
                            {text:'www.dw-systembau.de'},
                            {text:'info@dw-systembau.de'}
                        ],
                        margin:[50,10,0,0],alignment: 'right',style:'adresse'
                    }
                ],alignment: 'right'
            },
            {text:"Kostenvergleich zwischen BRESPA®-Decken, Halbfertigteildecken und Ortbetondecken",
                 style: 'header',margin:[0,20,0,0]
            },


            {table:tbl.table,style:'lauf',layout: 'noBorders',margin:[0,10,0,0]},

        ];
        tbl.table.body.push([{text: this.markbrespa("Erforderliche Dicke BRESPA®-Decke: " +brespastore.brespaselection.getCombinedVal())},"","",
            {table: {
                    widths: [55,20],
                    body: [[{text:Utils.rAndF(brespastore.plattendicke.value),bold:true,alignment:"right"},{text:"cm",bold:true,alignment:"left"}]]
                },layout: 'noBorders'}]);
        tbl.table.body.push([{text: this.markbrespa("Erforderliche Dicke Halbfertigteilecke: ")},"","",
            {table: {
                    widths: [55,20],
                    body: [[{text:Utils.rAndF(bstore.dickeforderlichhf.value),bold:true,alignment:"right"},{text:"cm",bold:true,alignment:"left"}]]
                },layout: 'noBorders'}]);
        tbl.table.body.push([{text: this.markbrespa("Erforderliche Dicke Ortbetondecke: ")},"","",
            {table: {
                    widths: [55,20],
                    body: [[{text:Utils.rAndF(bstore.dickeforderlichob.value),bold:true,alignment:"right"},{text:"cm",bold:true,alignment:"left"}]]
                },layout: 'noBorders'}]);
        if((bstore.dickeforderlichob.value - brespastore.plattendicke.value > 8)){
            base.push({text:`Für praxisgerechte Deckendicken und für einen realistischen Kostenvergleich wurden automatisch zusätzliche Deckenauflager für Halbfertigteile und Ortbetondecken zum Preis von ${bstore.kosten_stuetzung.value} €/lfd. m eingefügt, so dass die Deckendicken denen der BRESPA®-Decken entsprechen.` +
        "Die daraus entstandenen Mehrkosten wurden auf die m²-Preise umgelegt und sind unter „Kosten und Ergebnisse“ separat ausgewiesen.",fontSize: 10,margin:[0,20,0,0]})
        }
        let t = "Das Kalkulationsprogramm ist begrenzt auf den mehrgeschossigen Wohnungsbau im Umkreis von 400 km um unser Werk in Schneverdingen und einer Mindestgröße von 500 m². \nAls Einwirkungen dienen die üblichen Annahmen für den Wohnungsbau (Verkehrslast = 1,50 kN/m², Trennwandzuschlag = 0,80 kN/m²,  Ausstattung = 1,50 kN/m²). \nDie Kosten sind ohne „Gewinn- und Wagnisanteile“ für den Unternehmer. \nDas Programm ist nach heutigem Stand der Technik und nach bestem Wissen und Gewissen erstellt (Kostenansätze aus dem Großraum Hamburg, April 2019). \nTrotzdem können Fehler nicht ausgeschlossen werden. Die Nutzung erfolgt eigenverantwortlich und Haftungsansprüche gegenüber DW SYSTEMBAU GMBH sind ausgeschlossen. \nDas Kalkulationsprogramm ist urheberrechtlich geschützt!";
        base.push({text:t,fontSize: 8,margin:[0,20,50,0]});


        return base;
    }
    page_1(){
        let base =

            {
                stack:[{image:'dwdu',width:150},
                    {stack:[
                            {text:'DW SYSTEMBAU GMBH'},
                            {text:'Stockholmer Straße 1'},
                            {text:'29640 Schneverdingen\n\n'},
                            {text:'Fon +49(0) 5193 85 0\n\n'},
                            {text:'www.dw-systembau.de'},
                            {text:'info@dw-systembau.de'}
                        ],
                        margin:[50,10,0,0],alignment: 'right',style:'adresse'
                    }
                ],alignment: 'right',pageBreak: 'before'
            };
        let bstore = BaseEntriesStore;
        let brespastore = BrespaAnalyseStore;
        var tbl = {table: {
                widths: [220, '*','auto','auto'],
                body: []
            }};

        this.druckdaten.seite2.forEach((im)=>{
            console.log(im.field)
            let arr = []
            let d = this.pulldata(im,arr);
            arr.forEach((v)=>{
                if(v[0].type && v[0].type.indexOf("summary")>= 0){
                    if(v[0].type == "summary_material"){
                        tbl.table.body.push([{text: this.markbrespa("Gesamtmaterialkosten für das Herstellen von "+ Utils.rAndFNoDec(bstore.deckenflaeche.value)+" m²  BRESPA®-Deckenflächen, "+ brespastore.plattendicke.value + " cm")},"","",
                            {table: {
                                    widths: [65,20],
                                    body: [[{text:Utils.rAndF( brespastore.print_material_total),bold:true,alignment:"right"},{text:"€",bold:true,alignment:"left"}]]
                                },layout: 'noBorders'}]);
                           // {text:Utils.rAndF( brespastore.print_material_total) + "€", bold:true,alignment:'right'}])
                    }else{
                        tbl.table.body.push([{text: this.markbrespa("Gesamtlohnkosten für das Herstellen von "+ Utils.rAndFNoDec(bstore.deckenflaeche.value) +" m²  BRESPA®-Deckenflächen, "+ brespastore.plattendicke.value + " cm")},
                            "","",
                            {table: {
                                    widths: [65,20],
                                    body: [[{text:Utils.rAndF( brespastore.print_zeit_total * brespastore.lohnkosten.value),bold:true,alignment:"right"},{text:"€",bold:true,alignment:"left"}]]
                                },layout: 'noBorders'}])
                            //{text:Utils.rAndF(brespastore.print_zeit_total * brespastore.lohnkosten.value)+"€",bold:true,alignment:'right'}]);
                    }
                }else{
                    tbl.table.body.push(v)
                }
             });

        });
        tbl.table.body.push([{text: this.markbrespa("Herstellungskosten pro m² BRESPA®-Decke: " + brespastore.plattendicke.value+ ", Typ "+brespastore.brespaselection.getCombinedVal())},"","",
            {table: {
                    widths: [65,20],
                    body: [[{text:Utils.rAndF(brespastore.totalValueBrespa.value),bold:true,alignment:"right"},{text:"€",bold:true,alignment:"left"}]]
                },layout: 'noBorders'}]);
            //{text:Utils.rAndF(brespastore.totalValueBrespa.value) + "€",bold:true,alignment:'right'}])

        tbl.table.body.push([{text: this.markbrespa("Herstellungskosten für "+ Utils.rAndFNoDec(bstore.deckenflaeche.value)+" m²  BRESPA®-Decke "+ ", Typ "+brespastore.brespaselection.getCombinedVal())},"","",
            {table: {
                    widths: [65,20],
                    body: [[{text:Utils.rAndF(brespastore.totalValueBrespa.value * bstore.deckenflaeche.value),bold:true,alignment:"right"},{text:"€",bold:true,alignment:"left"}]]
                },layout: 'noBorders'}]);
        //{text:Utils.rAndF(brespastore.totalValueBrespa.value * bstore.deckenflaeche.value) + "€", bold:true,alignment:'right'}]);

        tbl.table.body.push([{text: this.markbrespa("Gesamtdauer für die Herstellung der " +Utils.rAndFNoDec(bstore.deckenflaeche.value) +" qm BRESPA®-Deckenflächen (4 Monteure):")},"","",
            {table: {
                    widths: [65,20],
                    body: [[{text:Utils.rAndF(brespastore.print_zeit_total),bold:true,alignment:"right"},{text:"h",bold:true,alignment:"left"}]]
                },layout: 'noBorders'}]);
        tbl.table.body.push([ "","","",
            {table: {
                    widths: [65,20],
                    body: [[{text:"~ "+ Utils.rAndFNoDec(brespastore.print_zeit_total/160.0),bold:true,alignment:"right"},{text:"W",bold:true,alignment:"left"}]]
                },layout: 'noBorders'}]);

        return [ base,{table:tbl.table,style:'lauf',layout: 'noBorders',margin:[0,10,0,0]}]
    }
    page_2(){
        let base =

            {
                stack:[{image:'dwdu',width:150},
                    {stack:[
                            {text:'DW SYSTEMBAU GMBH'},
                            {text:'Stockholmer Straße 1'},
                            {text:'29640 Schneverdingen\n\n'},
                            {text:'Fon +49(0) 5193 85 0\n\n'},
                            {text:'www.dw-systembau.de'},
                            {text:'info@dw-systembau.de'}
                        ],
                        margin:[50,10,0,0],alignment: 'right',style:'adresse'
                    }
                ],alignment: 'right',pageBreak: 'before'
            };
        let bstore = BaseEntriesStore;
        let hfstore = HalbfertigAnalyseStore;
        let brespastore = BrespaAnalyseStore;
        var tbl = {table: {
                widths: [220, '*','auto','auto'],
                body: []
            }};
        var qmval = hfstore.totalValue.value;
        var dval = bstore.erf_deckendicke;
        if((bstore.dickeforderlichob.value - brespastore.plattendicke.value > 8)){
            qmval = hfstore.totalValueBrespaStuetzung.value;
            dval = bstore.dicke_erforderlich_brespa.value
        }
        this.druckdaten.seite3.forEach((im)=>{
            console.log(im.field)
            if(im.field === "print_mehrkostenauflager" && !hfstore.needsStuetzung){return}
            let arr = []
            let d = this.pulldata(im,arr);
            arr.forEach((v)=>{
                if(v[0].type && v[0].type.indexOf("summary")>= 0){
                    if(v[0].type == "summary_material"){
                        tbl.table.body.push([{text: "Gesamtmaterialkosten für das Herstellen von "+ Utils.rAndFNoDec(bstore.deckenflaeche.value)+" m²  Halbfertigteildeckenflächen, "+ dval + " cm"},"","",
                            {table: {
                                    widths: [65,20],
                                    body: [[{text:Utils.rAndF( hfstore.print_material_total),bold:true,alignment:"right"},{text:"€",bold:true,alignment:"left"}]]
                                },layout: 'noBorders'}]);
                            //{text:Utils.rAndF( hfstore.print_material_total) + "€", bold:true,alignment:'right'}])
                    }else{
                        tbl.table.body.push([{text: "Gesamtlohnkosten für das Herstellen von "+ Utils.rAndFNoDec(bstore.deckenflaeche.value)+" m²  Halbfertigteildeckenflächen, "+ dval + " cm"},
                            "","",
                            {table: {
                                    widths: [65,20],
                                    body: [[{text:Utils.rAndF( hfstore.print_zeit_total * hfstore.lohnkosten.value),bold:true,alignment:"right"},{text:"€",bold:true,alignment:"left"}]]
                                },layout: 'noBorders'}]);
                        // {text:Utils.rAndF(hfstore.print_zeit_total * hfstore.lohnkosten.value)+"€",bold:true,alignment:'right'}]);
                    }
                }else{
                    tbl.table.body.push(v)
                }
            });

        });
        tbl.table.body.push([{text: "Herstellungskosten pro m² Halbfertigteildecke: " + dval+ " cm"},"","",
            {table: {
                    widths: [65,20],
                    body: [[{text:Utils.rAndF( qmval),bold:true,alignment:"right"},{text:"€",bold:true,alignment:"left"}]]
                },layout: 'noBorders'}]);
        // {text:Utils.rAndF(qmval) + "€",bold:true,alignment:'right'}]);

        tbl.table.body.push([{text: "Herstellungskosten für "+ Utils.rAndFNoDec(bstore.deckenflaeche.value)+" m²  Halbfertigteildeckenflächen, "+ dval + " cm"},"","",
            {table: {
                    widths: [65,20],
                    body: [[{text:Utils.rAndF( qmval * bstore.deckenflaeche.value),bold:true,alignment:"right"},{text:"€",bold:true,alignment:"left"}]]
                },layout: 'noBorders'}]);
            //{text:Utils.rAndF( qmval * bstore.deckenflaeche.value) + "€", bold:true,alignment:'right'}]);


        tbl.table.body.push([{text: "Gesamtdauer für die Herstellung der "+Utils.rAndFNoDec(bstore.deckenflaeche.value)+" m²"+" Halbfertigteildeckenflächen (4 Monteure):"},"","",
            {table: {
                    widths: [65,20],
                    body: [[{text:Utils.rAndF( hfstore.print_zeit_total),bold:true,alignment:"right"},{text:"h",bold:true,alignment:"left"}]]
                },layout: 'noBorders'}]);
        tbl.table.body.push([ "","","",
            {table: {
                    widths: [65,20],
                    body: [[{text:"~ "+ Utils.rAndFNoDec(hfstore.print_zeit_total/160.0),bold:true,alignment:"right"},{text:"W",bold:true,alignment:"left"}]]
                },layout: 'noBorders'}]);


        return [ base,{table:tbl.table,style:'lauf',layout: 'noBorders',margin:[0,10,0,0]}]
    }
    page_3(){
        let base =

            {
                stack:[{image:'dwdu',width:150},
                    {stack:[
                            {text:'DW SYSTEMBAU GMBH'},
                            {text:'Stockholmer Straße 1'},
                            {text:'29640 Schneverdingen\n\n'},
                            {text:'Fon +49(0) 5193 85 0\n\n'},
                            {text:'www.dw-systembau.de'},
                            {text:'info@dw-systembau.de'}
                        ],
                        margin:[50,10,0,0],alignment: 'right',style:'adresse'
                    }
                ],alignment: 'right',pageBreak: 'before'
            };
        let bstore = BaseEntriesStore;
        //let hfstore = HalbfertigAnalyseStore;
        let brespastore = BrespaAnalyseStore;
        let obstore = OrtbetonAnalyseStore;
        var tbl = {table: {
                widths: [220, '*','auto','auto'],
                body: []
            }};
        var qmval = obstore.totalValue.value;
        var dval = bstore.erf_deckendicke;
        if((bstore.dickeforderlichob.value - brespastore.plattendicke.value > 8)){
            qmval = obstore.totalValueBrespaStuetzung.value;
            dval = bstore.dicke_erforderlich_brespa.value
        }
        this.druckdaten.seite4.forEach((im)=>{
            console.log(im.field)
            if(im.field === "print_mehrkostenauflager" && !obstore.needsStuetzung){return}
            let arr = []
            let d = this.pulldata(im,arr);
            arr.forEach((v)=>{
                if(v[0].type && v[0].type.indexOf("summary")>= 0){
                    if(v[0].type == "summary_material"){
                        tbl.table.body.push([{text: "Gesamtmaterialkosten für das Herstellen von "+ Utils.rAndFNoDec(bstore.deckenflaeche.value)+" m² Ortbetondeckenflächen, "+ dval + " cm"},"","",
                            {table: {
                                    widths: [65,20],
                                    body: [[{text:Utils.rAndF( obstore.print_material_total),bold:true,alignment:"right"},{text:"€",bold:true,alignment:"left"}]]
                                },layout: 'noBorders'}]);
                            //{text:Utils.rAndF( obstore.print_material_total) + "€", bold:true,alignment:'right'}])
                    }else{
                        tbl.table.body.push([{text: "Gesamtlohnkosten für das Herstellen von "+ Utils.rAndFNoDec(bstore.deckenflaeche.value)+"m² Ortbetondeckenflächen, "+ dval + " cm"},
                            "","",
                            {table: {
                                    widths: [65,20],
                                    body: [[{text:Utils.rAndF( obstore.print_zeit_total * obstore.lohnkosten.value),bold:true,alignment:"right"},{text:"€",bold:true,alignment:"left"}]]
                                },layout: 'noBorders'}]);
                           // {text:Utils.rAndF(obstore.print_zeit_total * obstore.lohnkosten.value)+"€",bold:true,alignment:'right'}]);
                    }
                }else{
                    tbl.table.body.push(v)
                }
            });

        });

        tbl.table.body.push([{text: "Herstellungskosten pro m² Ortbetondeckenfläche: " + dval+ " cm"},"","",
            {table: {
                    widths: [65,20],
                    body: [[{text:Utils.rAndF( qmval ),bold:true,alignment:"right"},{text:"€",bold:true,alignment:"left"}]]
                },layout: 'noBorders'}]);
        // {text:Utils.rAndF(qmval) + "€",bold:true,alignment:'right'}]);

        tbl.table.body.push([{text: "Herstellungskosten für "+ Utils.rAndFNoDec(bstore.deckenflaeche.value)+" m² Ortbetondeckenflächen, "+ dval + " cm"},"","",
            {table: {
                    widths: [65,20],
                    body: [[{text:Utils.rAndF( qmval * bstore.deckenflaeche.value),bold:true,alignment:"right"},{text:"€",bold:true,alignment:"left"}]]
                },layout: 'noBorders'}]);
           // {text:Utils.rAndF( qmval * bstore.deckenflaeche.value) + "€", bold:true,alignment:'right'}]);

        tbl.table.body.push([{text: "Gesamtdauer für die Herstellung der "+Utils.rAndFNoDec(bstore.deckenflaeche.value)+" m²"+" Ortbetondeckenflächen (4 Personen):"},"","",
            {table: {
                    widths: [65,20],
                    body: [[{text:Utils.rAndF( obstore.print_zeit_total),bold:true,alignment:"right"},{text:"h",bold:true,alignment:"left"}]]
                },layout: 'noBorders'}]);
        tbl.table.body.push([ "","","",
            {table: {
                    widths: [65,20],
                    body: [[{text:"~ "+Utils.rAndFNoDec(obstore.print_zeit_total/160.0),bold:true,alignment:"right"},{text:"W",bold:true,alignment:"left"}]]
                },layout: 'noBorders'}]);


        return [ base,{table:tbl.table,style:'lauf',layout: 'noBorders',margin:[0,10,0,0]}]
    }


    page0(){
        let createBasicsTable = ()=>{
            let bstore = BaseEntriesStore;
            var arr = bstore.entries2.slice().concat(bstore.entries3.slice()).concat([new InputModel("Erf. Dicke <strong>BRESPA®</strong>-Decken",BrespaAnalyseStore.plattendicke.value,'cm')]).concat(bstore.entries4.slice());
            var tbl = {table: {
                    widths: ['auto', '*',50,'auto','*'],
                    body: []
                }};
            var cnt = 0;
            var cnt2 = 0;
            arr.forEach((im)=>{
                if(cnt <= 4){
                    var titl = Utils.stripTags(im.title);
                    tbl.table.body.push([titl,{text:im.getCombinedVal(),bold:true,alignment:'right'},'','',''])
                }else{
                    tbl.table.body[cnt2][3] = Utils.stripTags(im.title);
                    tbl.table.body[cnt2][4] = {text:im.getCombinedVal(),bold:true,alignment:'right'};
                    cnt2++;
                }

                cnt ++;
            });
            return tbl;
        };
        let createKostenTable = ()=> {
            let basestore = BaseEntriesStore
            let brespastore = BrespaAnalyseStore;
            let hfstore = HalbfertigAnalyseStore;
            let obstore = OrtbetonAnalyseStore;
            var toofat = basestore.totalDicke.value - brespastore.totalDicke.value > 8;
            let neededfieldsbrespa = (toofat)?
                [
                    'totalValueBrespa',
                    'totalKostenStuetzung',
                    'totalValueBrespaStuetzung'
                ]
                :
                [
                    'totalValueBrespa',
                    'totalDicke',
                ];
            let neededfieldsother = (toofat)?
                [
                    'totalValueBrespa',
                    'totalKostenStuetzung',
                    'totalValueBrespaStuetzung'
                ]
                :
                [
                    'totalValue',
                    'totalDicke',
                ];

            var tbl = {table: {
                    widths: ['auto',120,120,120],
                    body: [],
                    headerRows: 1
                }};
            tbl.table.body.push(['',{text:'BRESPA®-Decke',alignment:'right',bold:true},{text:'Halbfertigteildecke',alignment:'right',bold:true},{text:'Ortbetondecke',alignment:'right',bold:true}]);
            for (let i = 0; i < neededfieldsbrespa.length; i++) {
                let fb = neededfieldsbrespa[i];
                let fo = neededfieldsother[i];

                tbl.table.body.push([
                    {text:brespastore[fb].getTitleStripped()},
                    {text:brespastore[fb].getCombinedVal(),alignment:'right',bold:true },
                    {text:hfstore[fo].getCombinedVal(),alignment:'right',bold:true },
                    {text:obstore[fo].getCombinedVal(),alignment:'right',bold:true}
                ]);
            }

            return tbl;

        };
        let createEinzelPositionen = ()=> {
            let basestore = BaseEntriesStore
            let brespastore = BrespaAnalyseStore;
            let hfstore = HalbfertigAnalyseStore;
            let obstore = OrtbetonAnalyseStore;
          //  var toofat = basestore.totalDicke.value - brespastore.totalDicke.value > 8;
            let neededfieldsbrespa = brespastore.entries.slice().concat([brespastore.randschalung]).concat(brespastore.entries2.slice());
            let neededfieldshf =  ([hfstore.lohnkosten]).concat(basestore.detailEntries.slice()).concat(hfstore.entries.slice());
            let neededfieldsob =  ([obstore.lohnkosten]).concat(basestore.detailEntries.slice()).concat(obstore.entries.slice());

            var tbl = {table: {
                    widths: [100,50,100,50,100,50],
                    body: [],
                    headerRows: 1
                }};
            tbl.table.body.push([{text:'BRESPA®-Decke',alignment:'left',bold:true},'',{text:'Halbfertigteildecke',alignment:'left',bold:true},'',{text:'Ortbetondecke',alignment:'left',bold:true},'']);
            for (let i = 0; i < neededfieldsbrespa.length; i++) {
                //debugger

                tbl.table.body.push([
                    {text:neededfieldsbrespa[i].getTitleStripped()},
                    {text:neededfieldsbrespa[i].getCombinedVal(),alignment:'right',bold:true },
                    {text:neededfieldshf[i].getTitleStripped()},
                    {text:neededfieldshf[i].getCombinedVal(),alignment:'right',bold:true },
                    {text:neededfieldsob[i].getTitleStripped()},
                    {text:neededfieldsob[i].getCombinedVal(),alignment:'right',bold:true }
                ]);
            }

            return tbl;

        };
       let base =  [

            {
                stack:[{image:'dwdu',width:150},
                    {stack:[
                            {text:'DW SYSTEMBAU GMBH'},
                            {text:'Stockholmer Straße 1'},
                            {text:'29640 Schneverdingen\n\n'},
                            {text:'Fon +49(0) 5193 85 0\n\n'},
                            {text:'www.dw-systembau.de'},
                            {text:'info@dw-systembau.de'}
                        ],
                        margin:[50,10,0,0],alignment: 'right',style:'adresse'
                    }
                ],alignment: 'right'
            },

            {text: '',
                style: 'header',

            },
            {text: ['BV: '+ BaseEntriesStore.projektname.value + ' - PLZ: ' + BaseEntriesStore.plz.value+'\n',{text:'',style:"subheader"}],
                style: 'subheader',


            },
           {text: 'Basisdaten:',
               style: 'subheader',
               margin: [0,20,0,0]
           },
           {table:createBasicsTable().table,style:'lauf',layout: 'noBorders',margin:[0,10,0,0]},
           {text: 'Kosten:',
               style: 'subheader',
               margin: [0,20,0,0]
           },
           {table:createKostenTable().table,style:'lauf',layout: 'noBorders',margin:[0,10,0,0]},
           {text: 'Einzelpositionen:',
               style: 'subheader',
               margin: [0,20,0,0]
           },
           {table:createEinzelPositionen().table,style:'lauf',layout: 'noBorders',margin:[0,10,0,0]}
        ];






        return base;


    }

    page1() {
        return [
            {text: "Kostenschätzung\n\nder Life Cycle-Kosten für Ihre Parkbauten\n\n\n\n", style: 'header'},
            {image: 'prldu', width: 350,alignment:'center'},
            {style:'laufCenter',text:'\n\nOberflächenschutzsysteme für Parkbauten müssen nach der DIN 1045 nicht nur hohen Beanspruchungen durch Fahrverkehr standhalten, sie müssen auch über viele Jahre als Fahrbahnabdichtung bei jeder Witterung sicherstellen, dass kein Niederschlags– und Schmelzwasser sowie keine Tausalzlösungen in die Betondecken eindringen können.\n\nNach dem DBV-Merkblatt „Parkhäuser und Tiefgaragen“ kommen drei Oberflächenschutzsysteme in Frage: rissüberbrückende Kunststoffbeschichtungen (OS 11), starre Kunststoffbeschichtungen (OS 08) und Gussasphaltabdichtungen nach DIN 18195.\n\nDW SYSTEMBAU, Hofmeister Gussasphalt, Peikko Deutschland und Johannes Bau haben neben dem Parkhauskonzept Park»Raum auch einen Life Cycle-Kostenrechner entwickelt, mit dem sich ganzheitlich alle relevanten Kostenfaktoren - von den Herstellungskosten über die Betriebskosten und Mietausfälle bis hin zu den Entsorgungskosten - der verschiedenen Oberflächenschutzsysteme von 1 bis 50 Jahre bestimmen lassen.'},
            {text:'\n\n'},
            {image: 'startimg', width: 350,alignment:'center'}

            ];
    }


    getLineChartData(cb){
        var svg = document.querySelector('.recharts-surface');
        //var img = new Image();
        //img.width = window.jQuery(svg).width();
        //img.height = window.jQuery(svg).height();
        var canvas = document.createElement('canvas');
        canvas.width = window.jQuery(svg).width()+30;
        canvas.height = window.jQuery(svg).height()+10;
        // get svg data
                var xml = new XMLSerializer().serializeToString(svg);
        //canvg(canvas, xml,{offsetX:10,ignoreDimensions:true});
        //cb( canvas.toDataURL('image/png'));
        return;
       /*
                var svg64 = btoa(unescape(encodeURIComponent(xml)));
                var b64Start = 'data:image/svg+xml;base64,';


                var image64 = b64Start + svg64;

        img.onload = function () {


            document.querySelector('#cvs').appendChild(canvas);
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);
            document.querySelector('#cvs').appendChild(img)
            cb( canvas.toDataURL('image/png'));

        };

        img.src = image64;
        */
    }



}
export default new PdfCreator();


// WEBPACK FOOTER //
// ./src/utils/PdfCreator.js